import styled from 'styled-components';
import { ExpandableSection } from 'foundations-components/transitional/components/ExpandableSection';
import PropertySection from 'framework-asset-preview-lib/internal/properties/components/propertySections/PropertySection';
import StatisticPropertySection from 'framework-asset-preview-lib/internal/properties/components/propertySections/StatisticPropertySection';
import AssetSection from 'framework-asset-preview-lib/internal/assetPreview/components/AssetSection';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const StyledGroupSectionWithoutUIExpandable = styled.section.withConfig({
  displayName: "PerformanceGroupSection__StyledGroupSectionWithoutUIExpandable",
  componentId: "sc-16xtqkq-0"
})(["padding:0 20px;"]);
export default function PerformanceGroupSection({
  crmObject,
  performanceGroup,
  properties,
  propertyGroups
}) {
  const propertyValues = /*#__PURE__*/_jsx(AssetSection, {
    children: performanceGroup.stats.map((stat, index) => {
      if (stat.formatStyle === 'text' || stat.formatStyle === 'element') {
        return /*#__PURE__*/_jsx(PropertySection, {
          crmObject: crmObject,
          direction: "row",
          properties: properties,
          propertyName: stat.propertyName,
          renderLabel: stat.label ? () => /*#__PURE__*/_jsx(_Fragment, {
            children: stat.label
          }) : undefined,
          renderValue: stat.value != null ? () => /*#__PURE__*/_jsx("div", {
            style: {
              textAlign: 'right'
            },
            children: stat.value
          }) : undefined
        }, index);
      }
      if (stat.formatStyle === 'elementWithoutLabel') {
        return /*#__PURE__*/_jsx(PropertySection, {
          crmObject: crmObject,
          direction: "row",
          hideLabel: true,
          properties: properties,
          propertyName: stat.propertyName,
          renderValue: () => /*#__PURE__*/_jsx(_Fragment, {
            children: stat.value
          })
        }, index);
      }
      return /*#__PURE__*/_jsx(StatisticPropertySection, {
        crmObject: crmObject,
        formatStyle: stat.formatStyle,
        getValue: () => typeof stat.value === 'string' ? Number(stat.value) : stat.value || 0,
        properties: properties,
        propertyGroups: propertyGroups,
        propertyName: stat.propertyName
      }, index);
    })
  });
  if (performanceGroup.title) {
    return /*#__PURE__*/_jsx(ExpandableSection, {
      defaultOpen: true,
      titleText: performanceGroup.title,
      children: propertyValues
    });
  }
  return /*#__PURE__*/_jsx(StyledGroupSectionWithoutUIExpandable, {
    children: propertyValues
  });
}